export default __webpack_public_path__ + "static/media/glyph-purple.ff153727.svg";